import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'AP',
  name: 'Andrea P.',
  role: 'Docente universitaria — Lima, Perú',
  text: '"Mis alumnos por fin entienden la diferencia entre enfoque cuantitativo y cualitativo. Antes yo misma perdía tiempo buscando cómo explicarlo bien. Ahora entro al aula con todo listo."'
}, {
  initials: 'CM',
  name: 'Carlos M.',
  role: 'Profesor de metodología — Buenos Aires, Argentina',
  text: '"Nunca más llegué a una clase sin saber cómo explicar el planteamiento del problema o la diferencia entre tipos de diseño. El material hace el trabajo pesado por mí."'
}, {
  initials: 'SL',
  name: 'Sofía L.',
  role: 'Docente de posgrado — Bogotá, Colombia',
  text: '"Las planificaciones me ahorran horas. No improviso nunca más frente a mis alumnos."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-268" data-mp="2cdwkmapyakmt">
      <div className="max-w-7xl mx-auto px-4" data-id="element-269" data-mp="cdqsrv24tluh">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-270" data-mp="caw9i6uuu72n">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-271" data-mp="gby9ipwlin5o" data-mpi={i}>
              <div className="flex gap-1 text-gold mb-4" data-id="element-272" data-mp="144oj4sh10ucs">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-273" data-mp="190vrst0t4jyf" data-mpi={j} />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-274" data-mp="35xcsljk9ke10">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-275" data-mp="hzurwkor3fvn">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-276" data-mp="i0ebs6xyoecb">
                  {t.initials}
                </div>
                <div data-id="element-277" data-mp="r244rh7hrlc7">
                  <div className="font-bold text-white text-sm" data-id="element-278" data-mp="qygb8i21qyxh">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-279" data-mp="lzwncc3w7d2h">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}